/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/Title"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventActionDataTitleValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.title',
})
let constantData = 'task-title-'
let eventActionIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, eventActionIdValueData)
let tokensValueData = fromData.useDataFormat({ viewPath,
context: 'tokens',
format: fromHelpers.getToolbar,
})
let tokensValueData1 = fromData.useDataValue({ viewPath,
context: 'tokens',
})
let onChange = fromHelpers.useDataOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaTextareaLabel
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Title"
 required={true}
/>
<div
  data-testid="Title.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-5P3Cr': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 data="event_action.data.title"
 value={eventActionDataTitleValueData}
 onChange={onChange}
 data="'task-title-'"
 data="event_action.id"
 aggregate="/Data/aggregate.js joinNoSpace"
 containerId={aggregateData}
 marginTop={0}
 marginBottom={0}
 width="100%"
 parentHeight={36}
 toolbarPersist={false}
 data="tokens"
 format="helpers.js getToolbar"
 toolbar={tokensValueData}
 maxLength={10}
 placeholder="e.g. Schedule online appointment"
 data="tokens"
 tokens={tokensValueData1}
/>
</div>
{children}
</React.Fragment>)
}